import NoRows from './NoRows.component';

export default NoRows;
